/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextRomanLowercaseIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Roman Lowercase',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="22" x="14" y="4" />
    <rect height="4" rx="1" ry="1" width="22" x="14" y="16" />
    <rect height="4" rx="1" ry="1" width="22" x="14" y="28" />
    <path
      d="M10 2V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V2ZM8 4v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4ZM8 14v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V14ZM6 16v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V16ZM12 14v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V14ZM10 16v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V16ZM8 26v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V26ZM6 28v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V28ZM12 26v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V26ZM10 28v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V28ZM4 26v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V26ZM2 28v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V28Z"
    />
  </svg>`;
};
